import { Sun, Moon, Laptop, Sparkles, Palette } from 'lucide-react';
import useUIStore from '../store/useUIStore';

export default function ThemeToggle() {
  const { theme, setTheme, themePreset, setThemePreset } = useUIStore();

  return (
    <div className="flex items-center gap-2">
      {/* Theme Preset (Default / Sensei) */}
      <div className="flex items-center gap-1 rounded-lg border border-border bg-muted p-1">
        <button
          onClick={() => setThemePreset('default')}
          className={`control-inline-compact rounded-md transition-colors ${
            themePreset === 'default'
              ? 'bg-card shadow-sm text-primary'
              : 'text-muted-foreground hover:text-foreground'
          }`}
          title="Default Theme (Teal/Mint)"
        >
          <Palette className="h-4 w-4" />
        </button>
        <button
          onClick={() => setThemePreset('sensei')}
          className={`control-inline-compact rounded-md transition-colors ${
            themePreset === 'sensei'
              ? 'bg-card shadow-sm text-primary'
              : 'text-muted-foreground hover:text-foreground'
          }`}
          title="Sensei Theme (Orange/Warm)"
        >
          <Sparkles className="h-4 w-4" />
        </button>
      </div>

      {/* Color Mode (Light / System / Dark) */}
      <div className="flex items-center gap-1 rounded-lg border border-border bg-muted p-1">
        <button
          onClick={() => setTheme('light')}
          className={`control-inline-compact rounded-md transition-colors ${
            theme === 'light'
              ? 'bg-card shadow-sm text-primary'
              : 'text-muted-foreground hover:text-foreground'
          }`}
          title="Light Mode"
        >
          <Sun className="h-4 w-4" />
        </button>
        <button
          onClick={() => setTheme('system')}
          className={`control-inline-compact rounded-md transition-colors ${
            theme === 'system'
              ? 'bg-card shadow-sm text-primary'
              : 'text-muted-foreground hover:text-foreground'
          }`}
          title="System Scheme"
        >
          <Laptop className="h-4 w-4" />
        </button>
        <button
          onClick={() => setTheme('dark')}
          className={`control-inline-compact rounded-md transition-colors ${
            theme === 'dark'
              ? 'bg-card shadow-sm text-primary'
              : 'text-muted-foreground hover:text-foreground'
          }`}
          title="Dark Mode"
        >
          <Moon className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
